import { render, staticRenderFns } from "./VoucherViewDetail.vue?vue&type=template&id=1c4cb042&scoped=true&"
import script from "./VoucherViewDetail.vue?vue&type=script&lang=js&"
export * from "./VoucherViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./VoucherViewDetail.vue?vue&type=style&index=0&id=1c4cb042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4cb042",
  null
  
)

export default component.exports